import { Params } from '@angular/router';

export function isAutoLoginRequest(params: Params): boolean {
    return !!(params['base_url'] && params['username'] && params['password']);
}
